import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Link} from 'react-router-dom'
import {Grid, Button} from 'react-bootstrap'
import CategoriesList from "./categories-list";
import ProductSearchComponent from '../../../../common/search/simple-search-component'
import PageTitle from "../../../../common/page-title/index";
import ArrowButton from "../../../../common/button-arrow";
import {getCategories} from '../../../../../actions/categories'

import '../../common/styles.css'

class Categories extends Component {
  constructor(props){
    super(props);

    this.state = {
      query: ''
    }
  }

  componentWillMount() {
    this.props.dispatch(actions.reset('deep.admin_category'));
    this.props.dispatch({type: 'CLEAR_EDIT_CATEGORY'});
    this.props.dispatch(getCategories());
  }

  handleInputChange = (e) => {
    this.setState({query: e.target.value});
  };

  handleSearch = () => {
    const {query} = this.state;
    this.props.dispatch(getCategories(query));
  };

  handleClear = () => {
    this.setState({query: '',}, this.handleSearch);
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="products">
        <PageTitle>Categories</PageTitle>
        <Link to="/admin/categories/new">
          <ArrowButton color="red"
                       className="add-product"
                       submit={false}
                       arrow={false}
                       permissions={{
                         action: 'create',
                         subjectClass: 'Category'
                       }}>Add category</ArrowButton>
        </Link>

        <ProductSearchComponent searchValue={this.state.query}
                          onInputChange={this.handleInputChange}
                          onSearch={this.handleSearch}
                          onClear={this.handleClear}/>
        <CategoriesList
          categories={this.props.categories}
          fetching={this.props.fetching}
          fetched={this.props.fetched}
          onReorder={this.handleSearch}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.categories.categories,
    fetched: state.categories.fetched,
    fetching: state.categories.fetching,
  };
};

export default connect(mapStateToProps)(Categories);


// WEBPACK FOOTER //
// ./src/components/admin/products/categories/list/index.jsx